<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">ADVERSE REACTION/EVENT AND SEVERE ADVERSE EVENT</h3>
        </v-flex>
        <v-flex xs6>
          DATE: {{ adverse_reaction.date }}
        </v-flex>
        <v-flex xs6>
          <span class="pull-right">TIME: {{ adverse_reaction.time }}</span>
        </v-flex>
        <v-flex xs12>
          <p>NAME: {{ adverse_reaction.name }}</p>
          <p>AGE: {{ adverse_reaction.age }}</p>
          <p>GENDER: {{ adverse_reaction.sex }}</p>
          <p>LOCATION: {{ adverse_reaction.location }}</p>
          <hr class="transparent">
          <p class="reaction-title">Procedure/RX</p>
          <p class="reaction-detail" v-text="adverse_reaction.procedure"></p>
          <p class="reaction-title">Onset of event</p>
          <p class="reaction-detail" v-text="adverse_reaction.onset_of_event"></p>
          <p class="reaction-title">Medical Diagnosis</p>
          <p class="reaction-detail" v-text="adverse_reaction.medical_diagnosis"></p>
          <p class="reaction-title">Nature of Event</p>
          <p class="reaction-detail" v-text="adverse_reaction.nature_of_event"></p>
          <p class="reaction-title">Action Taken</p>
          <p class="reaction-detail" v-text="adverse_reaction.action_taken"></p>
          <hr class="transparent">
          <p class="reaction-title">Person Notified</p>
          <p class="reaction-detail" v-text="adverse_reaction.person_notified"></p>
          <p class="reaction-detail" v-text="adverse_reaction.person_notified_contact"></p>
          <br>
          <p class="reaction-title">Reporting Clinician</p>
          <p class="reaction-detail" v-text="adverse_reaction.reporting_clinician"></p>
          <p class="reaction-detail" v-text="adverse_reaction.signed"></p>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'ViewAdverseReaction',
    layout,
    props: [
      'adverse_reaction'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'ADVERSE REACTION/EVENT AND SEVERE ADVERSE EVENT',
        titleTemplate: '%s | ' + this.$title,
      }
    },
  }
</script>

<style>
  .reaction-detail {
    padding-left: 10px;
    margin-top: -20px;
  }
  .reaction-title {
    font-weight: bold;
  }
</style>
